import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate, useLocation, useParams } from "react-router-dom";
import AppLayout from "./AppLayout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Profile from "./pages/Profile/Profile";

import HomePageVitrine from "./pages/Home/HomePageVitrine.jsx";
import LoginPage from "./pages/LoginPage/LoginPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
import ResetPwd from "./pages/ResetPwd/ResetPwd";
import ForgotPasswordPage from "./pages/ResetPwd/ForgotPasswordPage";
import UnauthorizedPage from "./pages/UnauthorizedPage/UnauthorizedPage.jsx";

import Navbar2 from "./pages/Home/Navbar2/Navbar2";
import Footer from "./pages/Home/Footer";

// Contexts
import { UserProvider } from "./contexts/UserContext.js";
import PrimaryColorProvider from "./contexts/PrimaryColorProvider.jsx";
import { NotificationProvider } from "./contexts/NotificationContext.js";
import { ContactFormProvider } from "./contexts/ContactFormContext.js";
import { AccreditationProvider } from "./contexts/AccreditationContext.jsx";
import { useAccreditation } from "./contexts/AccreditationContext.jsx";

import ErrorPage from "./pages/ErrorPage/ErrorPage";

// PageVisiteurs

// Documents
import ReglementInterieur from "./pages/Documents/ReglementInterieur";
import ConditionsUtilisationPage from "./pages/rgpd/ConditionsUtilisationPage.jsx";
import PolitiqueConfidentialitePage from "./pages/rgpd/PolitiqueConfidentialitePage.jsx";
import FaqPage from "./pages/rgpd/FaqPage.jsx";
import MentionsLegalesPage from "./pages/rgpd/MentionsLegalesPage.jsx";

// Pages Visisteurs
import ArbitrageJudo from "./pages/Arbitrage/ArbitrageJudo";
import ArbitrageJJCombat from "./pages/ArbitrageJJCombat/ArbitrageJJCombat";
import ArbitrageJJDuo from "./pages/ArbitrageJJDuo/ArbitrageJJDuo";
import ReglementCS from "./pages/Arbitrage/ReglementCS";
import ResultsPublicPage from "./pages/ResultsPublicPage/ResultsPublicPage";
import CompetitionResultsPublic from "./pages/CompetitionResults/CompetitionResultsPublic";
import Scoreboard from "./pages/Scoreboard/Scoreboard";
import PricingPage from "./pages/PricingPage/PricingPage";
import CompetitionInvitationPage from "./pages/CompetitionJudokasPage/CompetitionInvitationPage";
import HelpPage from "./pages/HelpPage/HelpPage";
import FaqPublicResults from "./pages/HelpPage/FaqPublicResults.jsx";
import AccessAccreditationPage from "./pages/AccreditationsPage/AccessAccreditationPage";
import ScoreboardUserPage from "./pages/Scoreboard/ScoreboardUserPage.jsx";

// Pages Clients
import CompetitionPage from "./pages/Competition/CompetitionPage";
import CompetitionByIdPage from "./pages/CompetitionById/CompetitionByIdPage";
import RepartitionCompetiteursPage from "./pages/RepartitionCompetiteursPage/RepartitionCompetiteursPage";
import RepartitionCompetiteursTapisPage from "./pages/RepartitionCompetiteursTapisPage/RepartitionCompetiteursTapisPage";
import SuiviCombatsPage from "./pages/SuiviCombatsPage/SuiviCombatsPage";
import CompetitionJudokasPage from "./pages/CompetitionJudokasPage/CompetitionJudokasPage";
import PeseePage from "./pages/Pesee/PeseePage.jsx";
import TapisListPage from "./pages/TapisListPage/TapisListPage.jsx";
import CompetitionResults from "./pages/CompetitionResults/CompetitionResults";
import StatisticsCompetition from "./pages/StatisticsCompetition/StatisticsCompetition.jsx";
import AccreditationsPage from "./pages/AccreditationsPage/AccreditationsPage.jsx";
import PhotosPage from "./pages/PhotosPage/PhotosPage";
import ScoreboardPublic from "./components/ScoreboardAdmin/ScoreboardPublic.jsx";
import ScoreboardJJCombatPublic from "./components/ScoreboardAdmin/ScoreboardJJCombatPublic.jsx";
import ScoreboardNewazaPublic from "./components/ScoreboardAdmin/ScoreboardNeWazaPublic.jsx";
import DuoJudgePad from "./pages/DuoJudgePad/DuoJudgePad.jsx";
import InvitedClubPage from "./pages/InvitedClub/InvitedClubPage.jsx";
import PartenairesAdminPage from "./pages/PartenairesAdminPage/PartenairesAdminPage.jsx";
import MessagesPage from "./pages/MessagesPage/MessagesPage.jsx";
import CompetitionJudokaRegistrationPage from "./pages/CompetitionJudokaRegistrationPage/index.jsx";

// Pages Administrateurs
import UserListing from "./pages/UserListing/UserListing";
import Dashboard from "./pages/Dashboard/Dashboard";
import NotificationList from "./pages/NotificationList/NotificationList";
import ListingCompetitions from "./pages/ListingCompetitions/ListingCompetitions";
import ListingAchats from "./pages/ListingAchats/ListingAchats";
import ContactForm from "./pages/ContactForm/ContactForm.jsx";

// ... importez d'autres pages si nécessaire
import "./App.css";

const stripePromise = loadStripe(
  "pk_test_51POgHVEr14Icaey6JeVMxJf9bAJS9AxDAGUTSDI80b01LVDorrxErNHC1HbTU3WRgJfPD3P40daULyEzeakVDBfk00fHPS7sVp",
);

const App = () => {
  // Gestion des states
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const getLocalStorageItem = (key) => {
      try {
        console.log("Tentative de lecture du localStorage pour la clé:", key);
        const item = localStorage.getItem(key);
        console.log("Valeur obtenue:", item);
        return item ? JSON.parse(item) : null;
      } catch (error) {
        console.error(
          "Erreur lors de la lecture du localStorage pour la clé",
          key,
          ":",
          error,
        );
        return null;
      }
    };

    const storedUserInfo = getLocalStorageItem("userInfo");
    if (storedUserInfo) {
      setUserInfo(storedUserInfo);
    } else {
      console.error(
        "Les informations de l'utilisateur stockées sont introuvables ou corrompues.",
      );
      // Actions supplémentaires ici, comme une redirection ou une récupération depuis un serveur
    }
  }, []);

  // const RequireAuth = ({ children, roles }) => {
  //   const userInfo = JSON.parse(localStorage.getItem("userInfo")); // Assure-toi que userInfo est stocké dans localStorage
  //   const location = useLocation();

  //   if (!userInfo) {
  //     return <div>Chargement...</div>; // Ou un composant de chargement plus sophistiqué
  //   }

  //   if (roles && !roles.includes(userInfo.role_id)) {
  //     // Rôle non autorisé donc redirection vers une page d'erreur ou d'accueil
  //     return <Navigate to="/unauthorized" replace />;
  //   }

  //   return children;
  // };

  const RequireAuth = ({ children, roles }) => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const location = useLocation();
    const { accreditation } = useAccreditation();
    const { id: competitionId } = useParams();

    const currentPath = location.pathname;

    // ✅ Cas 1 : utilisateur connecté avec rôle autorisé
    if (userInfo && roles.includes(userInfo.role_id)) {
      return children;
    }

    // ✅ Cas 2 : accès via accréditation
    const isValidAccreditation =
      accreditation &&
      parseInt(accreditation.competition_id) === parseInt(competitionId) &&
      (() => {
        if (currentPath.includes("/judokas"))
          return accreditation.role === "Pesées";
        if (currentPath.includes("/repartition"))
          return accreditation.role === "Répartitions";
        if (currentPath.includes("/tapis/")) {
          const tableNumber = currentPath.split("/tapis/")[1];
          return accreditation.role === `Table ${tableNumber}`;
        }
        if (currentPath === `/competition/${competitionId}`)
          return accreditation.role === "Administrateur";
        return false;
      })();

    if (isValidAccreditation) {
      return children;
    }

    // ❌ Sinon, accès refusé
    return <Navigate to="/unauthorized" replace />;
  };

  return (
    <AccreditationProvider>
      <UserProvider>
        <Router>
          <Elements stripe={stripePromise}>
            <NotificationProvider>
              <ContactFormProvider>
                <PrimaryColorProvider>
                  <AppLayout userInfo={userInfo}>
                    <Routes>
                      {/* Route pour la page d'accueil du site vitrine */}
                      <Route path="/" element={<HomePageVitrine />} />

                      {/* VISITEURS */}
                      <Route path="/arbitrage" element={<ArbitrageJudo />} />
                      <Route
                        path="/arbitrage-jujitsu-combat"
                        element={<ArbitrageJJCombat />}
                      />
                      <Route
                        path="/arbitrage-jujitsu-duo"
                        element={<ArbitrageJJDuo />}
                      />
                      <Route path="/reglement-cs" element={<ReglementCS />} />
                      <Route
                        path="/resultats-public"
                        element={<ResultsPublicPage />}
                      />
                      <Route
                        path="/resultats-public/:competition_id"
                        element={<CompetitionResultsPublic />}
                      />
                      <Route
                        path="/tableau-de-score"
                        element={<Scoreboard />}
                      />
                      <Route
                        path="/tableau-de-score/:sessionId"
                        element={<ScoreboardUserPage />}
                      />
                      <Route
                        path="/formules-tarifs"
                        element={<PricingPage />}
                      />
                      <Route
                        path="/invitation/:competitionId"
                        element={<CompetitionInvitationPage />}
                      />
                      <Route
                        path="/inscription-judoka/:competitionId"
                        element={<CompetitionJudokaRegistrationPage />}
                      />
                      <Route path="/aide" element={<FaqPublicResults />} />
                      <Route
                        path="/competition-démo"
                        element={<CompetitionPage />}
                      />
                      <Route
                        path="/competition/:id/access"
                        element={<AccessAccreditationPage />}
                      />
                      <Route
                        path="/unauthorized"
                        element={<UnauthorizedPage />}
                      />

                      <Route
                        path="/score-public/:competitionId/:tapisId"
                        element={<ScoreboardPublic />}
                      />

                      <Route
                        path="/scoreboard-jjcombat/:competitionId/:tapisId"
                        element={<ScoreboardJJCombatPublic />}
                      />

                      <Route
                        path="/scoreboard-newaza/:competitionId/:tapisId"
                        element={<ScoreboardNewazaPublic />}
                      />

                      {/* CLIENTS */}

                      <Route
                        path="/profile"
                        element={
                          <RequireAuth roles={[2, 3, 1, 4]}>
                            <Profile />
                          </RequireAuth>
                        }
                      />

                      <Route
                        path="/competition"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <CompetitionPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/clubs-invites"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <InvitedClubPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:id"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <CompetitionByIdPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:id/judokas"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <PeseePage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:id/repartition"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <RepartitionCompetiteursPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:competition_id/tapis"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <TapisListPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:competition_id/tapis/:tapis_id"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <RepartitionCompetiteursTapisPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:competition_id/suivi-combats"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <SuiviCombatsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:competition_id/resultats"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <CompetitionResults />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/competition/:competition_id/stats"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <StatisticsCompetition />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/accreditations"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <AccreditationsPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/messages"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <MessagesPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/photos"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <PhotosPage />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/judge"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <DuoJudgePad />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/partenaires"
                        element={
                          <RequireAuth roles={[1, 2, 3, 4]}>
                            <PartenairesAdminPage />
                          </RequireAuth>
                        }
                      />

                      {/* ADMINISTRATEUR 1*/}
                      <Route
                        path="/listing-utilisateurs"
                        element={
                          <RequireAuth roles={[1]}>
                            <UserListing />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/listing-competitions"
                        element={
                          <RequireAuth roles={[1]}>
                            <ListingCompetitions />
                          </RequireAuth>
                        }
                      />

                      <Route
                        path="/listing-achats"
                        element={
                          <RequireAuth roles={[1]}>
                            <ListingAchats />
                          </RequireAuth>
                        }
                      />

                      <Route
                        path="/paramètres"
                        element={
                          <RequireAuth roles={[1]}>
                            <Dashboard />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/notifications"
                        element={
                          <RequireAuth roles={[1]}>
                            <NotificationList />
                          </RequireAuth>
                        }
                      />
                      <Route
                        path="/formulaire-contact"
                        element={
                          <RequireAuth roles={[1]}>
                            <ContactForm />
                          </RequireAuth>
                        }
                      />

                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route
                        path="/reset-password/:token"
                        element={<ResetPwd />}
                      />
                      <Route
                        path="/forgot-password"
                        element={<ForgotPasswordPage />}
                      />
                      <Route path="/404" element={<ErrorPage />} />
                      <Route path="*" element={<ErrorPage />} />

                      <Route
                        path="/reglement-interieur"
                        element={<ReglementInterieur />}
                      />
                      <Route
                        path="/conditions-utilisation"
                        element={<ConditionsUtilisationPage />}
                      />
                      <Route
                        path="/politique-confidentialite"
                        element={<PolitiqueConfidentialitePage />}
                      />
                      <Route path="/faq" element={<FaqPage />} />
                      <Route
                        path="/mentions-legales"
                        element={<MentionsLegalesPage />}
                      />
                    </Routes>
                  </AppLayout>
                </PrimaryColorProvider>
              </ContactFormProvider>
            </NotificationProvider>
          </Elements>
        </Router>
      </UserProvider>
    </AccreditationProvider>
  );
};

export default App;
